import { configureStore } from '@reduxjs/toolkit';
import confirmationReducer from './confirmation/reducer';
import userReducer from './user/reducer';
import appReducer from './app-settings/reducer';
import lovsReducer from './lovs/reducer';

const store = configureStore({
  reducer: {
    user: userReducer,
    confirmation: confirmationReducer,
    app: appReducer,
    lovs: lovsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
